module.exports = __webpack_public_path__ + "static/media/99gal49.72a932dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/99gal/99gal49.jpg
// module id = 330
// module chunks = 0